import { mdlActionTemplate } from "../models/domain/ActionTemplate";
import { mdlSpoAgency } from "../models/domain/SpoAgency";
import { mdlSpoBoard } from "../models/domain/SpoBoard";
import { mdlSpoMarket } from "../models/domain/SpoMarket";
import { mdlSpoOffer } from "../models/domain/SpoOffer";
import { mdlSpoOfferMessage } from "../models/domain/SpoOfferMessage";
import { mdlSpoRoomType } from "../models/domain/SpoRoomType";
import { mdlSpoMailPreviewItem } from "../models/domain/value-objects/SpoMailPreviewItem";
import { mdlSpoPreviewItem } from "../models/domain/value-objects/SpoPreviewItem";
import { mdlActionTemplateListRequest } from "../models/service-models/action/ActionTemplateListRequest";
import { mdlSpoCancelRequest } from "../models/service-models/action/SpoCancelRequest";
import { mdlSpoDeleteRequest } from "../models/service-models/action/SpoDeleteRequest";
import { mdlSpoMailPreviewRequest } from "../models/service-models/action/SpoMailPreviewRequest";
import { mdlSpoMailSendRequest } from "../models/service-models/action/SpoMailSendRequest";
import { mdlSpoOfferDetailRequest } from "../models/service-models/action/SpoOfferDetailRequest";
import { mdlSpoOfferDetailResponse } from "../models/service-models/action/SpoOfferDetailResponse";
import { mdlSpoPreviewRequest } from "../models/service-models/action/SpoPreviewRequest";
import { mdlSpoReportAgencyListRequest } from "../models/service-models/action/SpoReportAgencyListRequest";
import { mdlSpoReportBoardListRequest } from "../models/service-models/action/SpoReportBoardListRequest";
import { mdlSpoReportMarketListRequest } from "../models/service-models/action/SpoReportMarketListRequest";
import { mdlSpoReportRequest } from "../models/service-models/action/SpoReportRequest";
import { mdlSpoReportRoomTypeListRequest } from "../models/service-models/action/SpoReportRoomTypeListRequest";
import { mdlSpoSaveRequest } from "../models/service-models/action/SpoSaveRequest";
import { mdlSpoSendRequest } from "../models/service-models/action/SpoSendRequest";
import { mdlBaseDataResponse } from "../models/service-models/common/BaseDataResponse";
import { mdlBaseOperationResponse } from "../models/service-models/common/BaseOperationResponse";
import { mdlBaseRequest } from "../models/service-models/common/BaseRequest";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { GetResponse } from "../utils/ApiClient";

namespace ActionService {
    export async function SimpleSpoList(
        pRequest: mdlActionTemplateListRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlActionTemplate>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlActionTemplate>>>>(
            "spo/spo-list",
            pRequest
        );
    }

    export async function SpoOfferDetail(
        pRequest: mdlSpoOfferDetailRequest
    ): Promise<mdlServiceResponse<mdlSpoOfferDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlSpoOfferDetailResponse>>(
            "spo/spo-detail",
            pRequest
        );
    }

    export async function GetSpoMessages(
        pRequest: mdlBaseRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoOfferMessage>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoOfferMessage>>>>(
            "spo/spo-message-detail",
            pRequest
        );
    }

    export async function Delete(
        pRequest: mdlSpoDeleteRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "spo/delete",
            pRequest
        );
    }

    export async function Cancel(
        pRequest: mdlSpoCancelRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "spo/cancel",
            pRequest
        );
    }

    export async function Save(
        pRequest: mdlSpoSaveRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "spo/save",
            pRequest
        );
    }

    export async function Send(
        pRequest: mdlSpoSendRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "spo/send",
            pRequest
        );
    }

    export async function Preview(
        pRequest: mdlSpoPreviewRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<mdlSpoPreviewItem>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<mdlSpoPreviewItem>>>(
            "spo/spo-preview",
            pRequest
        );
    }

    export async function MailPreview(
        pRequest: mdlSpoMailPreviewRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<mdlSpoMailPreviewItem>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<mdlSpoMailPreviewItem>>>(
            "spo/spo-mail-preview",
            pRequest
        );
    }

    export async function SendMail(
        pRequest: mdlSpoMailSendRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "spo/send-mail",
            pRequest
        );
    }

    export async function Report(
        pRequest: mdlSpoReportRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoOffer>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoOffer>>>>(
            "spo/report",
            pRequest
        );
    }

    export async function ReportAgencyList(
        pRequest: mdlSpoReportAgencyListRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoAgency>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoAgency>>>>(
            "spo/report-agency-list",
            pRequest
        );
    }

    export async function ReportMarketList(
        pRequest: mdlSpoReportMarketListRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoMarket>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoMarket>>>>(
            "spo/report-hotel-market-list",
            pRequest
        );
    }

    export async function ReportBoardList(
        pRequest: mdlSpoReportBoardListRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoBoard>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoBoard>>>>(
            "spo/report-hotel-board-list",
            pRequest
        );
    }

    export async function ReportRoomTypeList(
        pRequest: mdlSpoReportRoomTypeListRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoRoomType>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlSpoRoomType>>>>(
            "spo/report-hotel-room-type-list",
            pRequest
        );
    }
}
export { ActionService };
